import React from "react";
import "../css/Common.css";
import about_us_img_1 from "../images/about_1.png";
import title_icon from "../images/title_shape_1.svg";
import img1 from "../images/about_feature_1_1.svg";
import img2 from "../images/about_feature_1_2.svg";
import img3 from "../images/about_2.png";
import Number_Statistics from "../components/Number_Statistics";
import { FaCheck } from "react-icons/fa";
import ChatButton from "../components/ChatButton";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";


const About = () => {
  return (
    <>
    <Helmet>
      <title>About CreduMoney</title>
      <meta name="title" content="About CreduMoney"/>
      <meta name="description" content="CreduMoney is a trusted non-banking financial company located in New Delhi. It provides best personal loan for various purposes. Apply today at CreduMoney for best instant personal loan"/>
    </Helmet>

      <div className="page_wrapper">
        <div className="page_banner_wrapper">
          <div className="page_banner_wrapper_overlay">
            <h2>About Us</h2>
            <div style={{ marginTop: "10px" }}>
              <Link 
                to="/" 
                style={{ 
                  color: "#26b9db", 
                  fontWeight: "600", 
                  fontSize: "14px", 
                  textDecoration: "none" 
                }}
              >
                Home
              </Link>
              <span style={{ color: "white", fontSize: "16px", margin: "0 10px" }}>→</span>
              <span style={{ color: "white", fontWeight: "600", fontSize: "16px" }}>
                About Us
              </span>
            </div>
          </div>
        </div>

        <div className="company_info_section">
          <div className="company_info_wrapper">
            <div className="title_section">
              <h2 className="full-width text-center">Credu Money</h2>
            </div>
            <p className="text-center  company_info_content">
           CreduMoney is an RBI-registered NBFC(Non-Banking Financial Company) that offers Instant Personal Loans to salaried employees across forty cities in India, including top-tier cities such as Delhi, Noida, Gurugram, Bangalore, Hyderabad, Kolkata, Mumbai, etc. We cater to a diverse variety of loan requirements, such as personal loans for travel, personal loans for medical emergencies, personal loans for home renovation, personal loans for education/higher studies, personal loans for special occasions, personal loans for wedding/festival shopping, and many more. 
            </p>
            {/* <div className="button_container">
               <button >
                   Meet Our Leaders
               </button>
               <button>
                Join Our Team
               </button>
            </div> */}
          </div>
        </div>
        <div className="about_us_section_1" data-aos="fade-down">
          <div className="about_us_section_1_left">
            <img src={about_us_img_1} alt="" />
          </div>
          <div className="about_us_section_1_right">
            <div className="title_section">
              <p className="sub_title flex flex-center">
                <img src={title_icon} alt="" className="mr10" />
                <span>About us</span>
              </p>
              <h2 className="mt20">
                Discover CreduMoney: Your Partner in{" "}
                <span>Financial Growth</span>
              </h2>
            </div>
            <p className="mt30">
           If you’re a salaried employee, you can secure an instant personal loan of up to 1 LAKH rupees in just 10 minutes. Yes! All we need is just 10 minutes to provide you with the funds you need. It is because the entire process — from loan application to approval and disbursal — is 100% digital, fast, and hassle-free. No paperwork, no long queues, and no unnecessary delays. Just a smooth, transparent experience designed to meet your financial needs instantly. When it comes to the documentation, all you need to have is PAN, Aadhar, a bank statement, etc.
            </p>

            <p className="mt30">
              Whether you’re planning a much-needed vacation, facing an unexpected medical emergency, renovating your home, funding higher education, shopping for a wedding or festival, upgrading your gadgets, clearing credit card bills, or simply need extra funds for a special occasion, CreduMoney has got you comprehensively covered. We believe you must not compromise on your needs, opportunity, adventure or luxury because of a shortage of funds. We aim to establish ourselves as the best NBFC in India and the first choice among loan seekers.
            </p>

            <div className="about_features_section">
              <div className="about_features_item flex flex-center">
                <div>
                  <img src={img1} alt="" />
                </div>
                <div className="ml10">
                  <h3>Certified Company</h3>
                  <p style={{ minWidth: "fit-content" }}>
                    All products certified by RBI
                  </p>
                </div>
              </div>
              <div className="about_features_item flex flex-center">
                <div>
                  <img src={img2} alt="" />
                </div>
                <div className="ml10" style={{ minWidth: "fit-content" }}>
                  <h3>Experienced Team</h3>
                  <p>Certified Professionals</p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Number_Statistics />
        <div className="about_us_section_1 pt90">
          <div className="about_us_section_1_right">
            <div className="title_section">
              <p className="sub_title flex flex-center">
                <img src={title_icon} alt="" className="mr10" />
                <span>Why Choose Us</span>
              </p>
              <h2 className="mt20">
                Our Vision
              </h2>
            </div>
            <p className="mt30">
            CreduMoney was founded on the core principle of making the lives of salaried employees easy by offering effective solutions to financial hardships. Recognising that India is a nation full of young individuals with a diverse range of expenses, we ensure they’re always on top of their budget, making the most of opportunities that come their way. We aim to empower their present and future, making them achieve their goals effortlessly.
            </p>

            <div className="title_section">
             
             
              <h2 className="mt20">
                Our Mission
              </h2>
            </div>
            
<p className="mt30">
  At CreduMoney, our mission is to empower every working individual with instant, reliable, and accessible financial support—anytime they need it. We aim to become the most trusted and preferred digital lending platform for short-term personal loans by delivering speed, simplicity, and security through innovative technology and customer-first service.
We believe that no one should have to wait for their salary to meet essential needs. With CreduMoney, financial freedom comes without the wait.

</p>
            
          </div>
          <div className="about_us_section_1_2_left">
            <div className="img1">
              <img src={img3} alt="" />
            </div>
          </div>
        </div>

        {/* <div className="about_us_section_1">
          <div className="about_us_section_1_right">
            <div className="title_section">
              <p className="sub_title flex flex-center">
                <img src={title_icon} alt="" className="mr10" />
                <span>Why Choose Us</span>
              </p>
              <h2 className="mt20">
                Our
                <span> Partners</span>
              </h2>
              <div className="partner_image">
                <Link to="https://moneybip.com/" target="_blank">
              <img src={moneybip} alt="" className="mr10"  style={{width:"65%",padding:"30px",marginBottom:"45px"}}/>
              </Link>
              </div>
            </div>
          </div>
        </div> */}
      </div>
      <ChatButton />
    </>
  );
};

export default About;
